export var ContextWebGLFlags = {
    /**
     * Preferred  WebGL version for rendering
     * @default WEBGL2
     */
    PREF_VERSION: 2 /* WEBGL2 */,
    /**
     * Preferred  multisample for webgl2 on rendertargets.
     * @default true
     */
    PREF_MULTISAMPLE: true,
    /**
     * Preferred mipmaps for textures
     * @default ALL
     */
    PREF_MIPMAP: 1 /* ALL_TEXTURES */,
    /**
     * Preferred repeate wrapping for all type of textures, on webg1 will throw a warn for nPOT textures
     * ContextWebGLPreference.POT_TEXTURES will allow only for POT textures on WebGL1
     * @default ALL_TEXTURES
     */
    PREF_REPEAT_WRAP: 1 /* ALL_TEXTURES */
};
